import config from 'config'
import { AdminError } from 'types/AdminError'
import { SupportContactPreviewProps } from 'types/SupportContactPreviewProps'
import { fetchWithToken } from 'utils'
import externalAdminFiltersToString from './externalAdminFiltersToString'

export interface BillingAdmin {
  key: string
  firstName: string
  lastName: string
  email: string
}
export interface Account {
  billingUserKey?: string
  country: string
  billingAdmin?: BillingAdmin
  errors?: AdminError[]
  name?: string
  partnerSupportContact?: Partial<SupportContactPreviewProps>
  parentContactDetails?: Partial<SupportContactPreviewProps>
  partnerAccountKey?: string
  toggleUnifiedAdmin?: boolean
  unifiedAdmin: boolean
  goToAdminTime?: number
  parent?: boolean
  parentKey?: string
}

/**
 * Retrieves an Account by account key
 */
const fetchAccount = (accountKey: string): Promise<Account | null> =>
  fetchWithToken({
    method: 'GET',
    useV5: false,
    useVersion: '',
    baseUrl: config.EXTERNAL_ADMIN_URL,
    resource: 'ext-admin/rest',
    path: `accounts/${accountKey}`,
    filters: externalAdminFiltersToString({}),
  })
    .then((response: Response) => response.json())
    .catch((err: AdminError) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })

export default fetchAccount
